import { useEffect, type RefObject } from 'react'
import { useUi } from '@/store/ui'

/**
 * Plays the "here it is" sheen on a task's row or block when that task is the
 * one just added or shown, as a task card does on the Plan tab. A class toggled
 * on the element, so nothing re-renders.
 */
export function useSheen(ref: RefObject<HTMLElement | null>, taskId: string): void {
  const nonce = useUi((s) => (s.highlight?.id === taskId ? s.highlight.nonce : null))
  useEffect(() => {
    const el = ref.current
    if (!nonce || !el) return
    el.classList.remove('csheen')
    void el.offsetWidth
    el.classList.add('csheen')
    const timer = window.setTimeout(() => el.classList.remove('csheen'), 1600)
    return () => window.clearTimeout(timer)
  }, [nonce, ref])
}
